namespace Recommendations {
    function HotelListRecommender(
        $routeParams: any,
        basketService: any,
        broker: Core.Broker,
        preferences: any,
        recommender: any,
        recommenderUiHelper: RecommenderUiHelper,
        $q: ng.IQService,
        $timeout: ng.ITimeoutService,
        tripService: Core.TripService
    )
    {
        function init($scope, $element) {
            $scope.hotels = [];
            let timeoutToAvoidPageFlicker = $timeout(angular.noop, 500);

            tripService
                .usePackageRates()
                .then(usePackageRates => {
                    if (usePackageRates) {
                        return $q.reject();
                    }
                })
                .then(() => tripService.getTrip($routeParams.tripId))
                .then(trip => {
                    const isHotel = trip && trip.TripType === Core.Trip.TripType.Hotel;
                    const isHotelPage = !!$scope.currentEstab;
                    const placementId = recommender.createPlacementId(isHotel, isHotelPage);
                    const searchModel = {
                        destination: _.get(trip, 'HotelsRequest.Destination'),
                        startDate: _.get(trip, 'HotelsRequest.CheckInDate'),
                        endDate: _.get(trip, 'HotelsRequest.CheckOutDate'),
                        occupancy: _.get(trip, 'HotelsRequest.Rooms')
                    };
                    return recommender.continueSearch(
                        $scope.currentEstab, searchModel, isHotel, placementId, $routeParams.tripId);
                })
                .then(response => timeoutToAvoidPageFlicker.then(() => response))
                .then(({ hotels, trackView, trackClick }) => {
                    if (!hotels || !hotels.length) {
                        trackView(0, 0, 0, []);
                        return;
                    }
                    _.assign(
                        $scope,
                        {
                            hotels,
                            selectHotel: hotel => {
                                hotel.loading = true;
                                trackClick(hotel, recommenderUiHelper.getPageSize());
                                tripService
                                    .getTrip($routeParams.tripId)
                                    .then(trip =>
                                        trip.TripType === Core.Trip.TripType.Hotel
                                        ? recommenderUiHelper.toNewTrip(hotel)
                                        : basketService.selectHotel(trip.TripId, hotel, trip.BasketId))
                                    .then(() => hotel.loading = false);
                            }
                        }
                    );
                    recommenderUiHelper.bindCarouselEvents($element, hotels, trackView);
                });
        }

        return {
            scope: {
                currentEstab: '='
            },
            templateUrl: 'partials/recommendations/hotellistrecommender',
            link($scope, $element) {
                const bouncedInit = _.debounce(() => init($scope, $element), 2500);

                init($scope, $element);
                broker.subscribe('hotelListRecommender', 'searchCriteriaModified', bouncedInit);

                preferences.get('priceMode').then(p => {
                    $scope.priceMode = p;
                    broker.subscribe(
                        'hotelListRecommender',
                        'priceModeChanged',
                        ({ data }) => $scope.priceMode = data
                    );
                });
            }
        };
    }

    angular
        .module('recommendations')
        .directive('hotelListRecommender', HotelListRecommender);
}
